import globalEvents from '@/services/GlobalEvents/GlobalEvents'
import { Events } from '@/services/GlobalEvents/constants'
import { ShowProps } from './IUserNotify'

export const show = (props: ShowProps) => {
  globalEvents.emit(Events.showUserNotice, props)
}
